var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "security-fallback-tab" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "a-form",
        { staticClass: "settings-form", attrs: { layout: "vertical" } },
        [
          _c("div", { staticClass: "settings-section" }, [
            _c(
              "div",
              { staticClass: "setting-header" },
              [
                _c("div", { staticClass: "setting-title" }, [
                  _c("h4", [_vm._v("Hassas Veri Depolama Dışında Kalma")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-description" }, [
                    _vm._v(
                      "\n                        Transkript, kayıt, loglama, telefon numaraları gibi hassas verilerin depolanmasını engeller.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  on: { change: _vm.updateSettings },
                  model: {
                    value: _vm.formData.opt_out_sensitive_data_storage,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "opt_out_sensitive_data_storage",
                        $$v
                      )
                    },
                    expression: "formData.opt_out_sensitive_data_storage",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "description" },
                [
                  _c("a-alert", { attrs: { type: "info", "show-icon": "" } }, [
                    _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                      _vm._v(
                        "\n                            Bu seçeneği etkinleştirdiğinizde, arama ile ilgili hassas veriler sistemde saklanmaz. Bu\n                            veriler yalnızca webhook'lar aracılığıyla güvenli bir şekilde erişilebilir. Varsayılan\n                            olarak devre dışıdır.\n                        "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [_vm._v("Yedek Ses Seçimi")]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-description" }, [
                _vm._v(
                  "\n                    Ana ses kullanılamadığında kullanılacak yedek sesleri belirleyin.\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "setting-content" },
              [
                _c("div", { staticClass: "description" }, [
                  _c("p", [
                    _vm._v(
                      "\n                        Seçilen yedek sesler, ana ses servis dışı kaldığında sırayla kullanılır. Yedek sesler ana\n                        ses sağlayıcısından farklı olmalıdır.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.formData.fallback_voice_ids &&
                _vm.formData.fallback_voice_ids.length > 0
                  ? _c("div", { staticClass: "selected-fallback-voices" }, [
                      _c("h5", [_vm._v("Seçilen Yedek Sesler:")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fallback-voice-list" },
                        _vm._l(
                          _vm.formData.fallback_voice_ids,
                          function (voiceId, index) {
                            return _c(
                              "a-tag",
                              {
                                key: index,
                                attrs: { closable: "" },
                                on: {
                                  close: function ($event) {
                                    return _vm.removeVoiceFromFallback(index)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.getVoiceName(voiceId)) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-voice-button",
                    attrs: { type: "dashed" },
                    on: { click: _vm.showVoiceSelector },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(" Yedek Ses Ekle\n                "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-modal",
                  {
                    attrs: {
                      title: "Yedek Ses Seçimi",
                      width: "800px",
                      footer: null,
                    },
                    model: {
                      value: _vm.voiceSelectorVisible,
                      callback: function ($$v) {
                        _vm.voiceSelectorVisible = $$v
                      },
                      expression: "voiceSelectorVisible",
                    },
                  },
                  [
                    _c("p", { staticClass: "modal-info" }, [
                      _vm._v(
                        "\n                        Ana ses sağlayıcısından farklı bir ses sağlayıcısı seçmeniz gerekmektedir.\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("voice-selector", {
                      on: { select: _vm.addVoiceToFallback },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [_vm._v("Varsayılan Dinamik Değişkenler")]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-description" }, [
                _vm._v(
                  "\n                    Ajandaki dinamik değişkenlerin varsayılan değerlerini tanımlayın.\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "setting-content" },
              [
                _c("div", { staticClass: "description" }, [
                  _c("p", [
                    _vm._v(
                      "\n                        Prompt ve araç açıklamalarındaki "
                    ),
                    _c("span", { pre: true }, [_vm._v("{{ değişken_adı }}")]),
                    _vm._v(
                      " biçimindeki dinamik\n                        değişkenlerin varsayılan değerlerini atayın.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.extractedVariables.length > 0
                  ? _c(
                      "div",
                      { staticClass: "extracted-variables-info" },
                      [
                        _c(
                          "a-alert",
                          { attrs: { type: "success", "show-icon": "" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "message" }, slot: "message" },
                              [
                                _c("span", [
                                  _vm._v("Prompt içinde bulunan değişkenler: "),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.extractedVariables,
                                  function (variable) {
                                    return _c("a-tag", { key: variable }, [
                                      _vm._v(_vm._s(variable)),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dynamic-variables-list" },
                  _vm._l(_vm.dynamicVariables, function (value, key, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "dynamic-variable-item" },
                      [
                        _c("div", { staticClass: "variable-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "variable-input-group" },
                            [
                              _c("a-input", {
                                staticClass: "variable-key",
                                attrs: {
                                  "addon-before": "{{",
                                  "addon-after": "}}",
                                  value: key,
                                  placeholder: "değişken_adı",
                                },
                                on: {
                                  change: function (e) {
                                    return _vm.updateVariableKey(
                                      key,
                                      e.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "variable-value",
                                attrs: { placeholder: "Değer" },
                                on: { change: _vm.updateSettings },
                                model: {
                                  value: _vm.dynamicVariables[key],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dynamicVariables, key, $$v)
                                  },
                                  expression: "dynamicVariables[key]",
                                },
                              }),
                              _vm._v(" "),
                              _c("a-button", {
                                attrs: { type: "danger", icon: "delete" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeVariable(key)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-variable-button",
                    attrs: { type: "dashed" },
                    on: { click: _vm.addVariable },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(" Değişken Ekle\n                "),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.update"] } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.isSaving },
                      on: { click: _vm.saveSettings },
                    },
                    [_vm._v(" Değişiklikleri Kaydet")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-header" }, [
      _c("h3", [_vm._v("Güvenlik ve Yedekleme Ayarları")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Ajanın veri güvenliği, ses yedeklemesi ve dinamik değişken ayarlarını yapılandırın."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }